module.exports = __webpack_public_path__ + "media/images/application/template/boxplus/blue-box-storage-logo-7f4ddc3277f783bc05300596d47618ef.png";